export default {
  BASE_TRANSPORT_INDEX: 0,
  SIBLING_TRANSPORT_INDEX: 1,
};



// WEBPACK FOOTER //
// ./src/variables/transportIndexes.js